import { Injectable } from '@angular/core';
import { HostLocationService } from './hostLocation.service';
import { HelperFunctions } from 'src/app/utils/helper.functions';

@Injectable({
  providedIn: 'root',
})
export class PlatformNameService {
  static readonly PLATFORM_NAMES = {
    EYEQ: 'EyeQ',
    ATOM: 'ATOM',
    ZEUS: 'Zeus',
    IPL: 'Zeus',
  };
  private platformInfo = {
    wincanton: { name: PlatformNameService.PLATFORM_NAMES.EYEQ, favicon: 'assets/images/faviconEyeQ.png' },
    apollo: { name: PlatformNameService.PLATFORM_NAMES.ATOM, favicon: 'assets/images/faviconAtom.png' },
    atom: { name: PlatformNameService.PLATFORM_NAMES.ATOM, favicon: 'assets/images/faviconAtom.png' },
    ipl: { name: PlatformNameService.PLATFORM_NAMES.IPL, favicon: 'assets/images/faviconIpl.png' },
    zeus: { name: PlatformNameService.PLATFORM_NAMES.ZEUS, favicon: 'assets/images/favicon.png' },
  };

  private platformName: string;

  constructor(private hostLocationService: HostLocationService, private helperFunction: HelperFunctions) {
    this.setPlatformName();
  }

  private setPlatformName(): void {
    const host = this.hostLocationService.getHost();
    const project = this.helperFunction.getEnvironmentAndProject(host).project;
    this.platformName = this.platformInfo[project].name;
  }

  getPlatformName(): string {
    return this.platformName;
  }

  getFavicon(): string {
    const host = this.hostLocationService.getHost();
    const project = this.helperFunction.getEnvironmentAndProject(host).project;
    return this.platformInfo[project].favicon;
  }

  isEyeQMarketplace(): boolean {
    return this.getPlatformName() === PlatformNameService.PLATFORM_NAMES.EYEQ;
  }

  isAtom(): boolean {
    return this.getPlatformName() === PlatformNameService.PLATFORM_NAMES.ATOM;
  }

  isIpl(): boolean {
    return this.getPlatformName() === PlatformNameService.PLATFORM_NAMES.IPL;
  }
}
